"use strict";

document.addEventListener("DOMContentLoaded", () => {
    var recentlyViewed = {};

    (function () {
        var $this;

        recentlyViewed = {
            productHandle : null,
            rvCookie: null,
            rvProducts: [],
            displayProducts: [],
            rvProductArray: [],

            /*
			 * Initialize
			 */
			init: function () {

                $this = recentlyViewed;

                const productSection = document.querySelector(".js-product_section[data-rv-handle]");
                const rvProductSection = document.querySelector(".recently-viewed__section");

                if (productSection) {
                    $this.productHandle = productSection.dataset.rvHandle.toString();
                }

                // このセクションの保存期間（data-retention-days属性、なければ30日）
                const retentionDays = parseInt(
                    (rvProductSection && rvProductSection.dataset.retentionDays) || "30",
                    10
                );

                // localStorageから取得。保存時のクリーンアップは schema 最大値（30日）で行い、
                // セクションごとの個別保存期間は表示時のフィルタで実現する
                // （短期保存期間のセクションを経由しても長期データが消えないようにする）
                const MAX_RETENTION_DAYS = 30;
                let stored = $this.getStoredProducts();
                stored = $this.filterByRetention(stored, MAX_RETENTION_DAYS);

                // 商品ページ閲覧時：現在商品を先頭に追加（既存エントリは削除して重複を防ぐ）
                if ($this.productHandle) {
                    stored = stored.filter(item => item.handle !== $this.productHandle);
                    stored.unshift({ handle: $this.productHandle, timestamp: Date.now() });
                    $this.setStoredProducts(stored);
                }

                // 表示用ハンドル配列：このセクションの保存期間でフィルタ
                $this.displayProducts = $this.filterByRetention(stored, retentionDays)
                    .map(item => item.handle);

                const recentlyViewedSections = document.querySelectorAll(".recently-viewed__section");
                if (recentlyViewedSections.length > 0) {
                    recentlyViewedSections.forEach(el => {
                        if (el.querySelector(".rv-main")) {
                            $this.getProductInformation(el, $this.displayProducts, $this.productHandle);
                        }
                    });
                }
            },

            /*
			 * Get Stored Products (localStorage)
			 * 形式: [{ handle: string, timestamp: number(ms) }, ...]
			 */
            getStoredProducts: function () {
                try {
                    const raw = localStorage.getItem("recentlyViewed");
                    if (!raw) return [];
                    const parsed = JSON.parse(raw);
                    return Array.isArray(parsed) ? parsed : [];
                } catch (e) {
                    return [];
                }
            },

            /*
			 * Set Stored Products (localStorage)
			 */
            setStoredProducts: function (items) {
                try {
                    localStorage.setItem("recentlyViewed", JSON.stringify(items));
                } catch (e) {
                    // localStorage が利用不可・容量超過の場合は無視
                }
            },

            /*
			 * Filter by Retention Period
			 */
            filterByRetention: function (items, retentionDays) {
                if (!retentionDays) return items;
                const expiryMs = retentionDays * 24 * 60 * 60 * 1000;
                const now = Date.now();
                return items.filter(item =>
                    item && item.handle && (now - (item.timestamp || 0)) <= expiryMs
                );
            },

            /*
			 * Display Recently Viewed Products
			 */
            getProductInformation: function(parent, displayProducts, productHandle) {

                const productLimit = parent.dataset.visibleProducts;
                const enableMobileSettings = parent.dataset.enableMobileSettings === 'true';
                const displayModeMobile = parent.dataset.displayModeMobile;
                const mobileProdLimit = parent.dataset.visibleProductsMobile;

                // 260920改修②：data-exclude-current="true" のセクションでは表示中の商品自身を除外する
                if (parent.dataset.excludeCurrent === 'true' && productHandle && displayProducts) {
                    displayProducts = displayProducts.filter(handle => handle !== productHandle);
                }

                const allDisplayProducts = displayProducts ? Array.from(displayProducts) : [];

                if (productLimit && displayProducts) {
                    displayProducts = displayProducts.slice(0, productLimit);
                }

                const mobileDisplayProducts = (enableMobileSettings && mobileProdLimit)
                    ? allDisplayProducts.slice(0, parseInt(mobileProdLimit, 10))
                    : [];

                if (displayProducts.length > 0) {
                    const arrowBtn = parent.querySelector(".wbhomesbtn");
                    const column = window.outerWidth > 991 ? +parent.dataset.column : 2;
                    const showArrows = parent.dataset.showArrows !== 'false';
                    if(arrowBtn && (!showArrows || displayProducts.length < column)) arrowBtn.classList.add("hidden")
                    else if(arrowBtn && showArrows) arrowBtn.classList.remove("hidden")

                    displayProducts.forEach((product, index) => {
                        if (product) {
                            parent.classList.remove("hidden");

                            fetch(`/products/${product}?view=rv`).then(function(response) {
                                return response.text();
                            }).then(function(data) {
                                var parser = new DOMParser();

                                var data = parser.parseFromString(data, "text/html");

                                const rvProductHTML = data.querySelector(".js-recently-viewed-product");
                                if (rvProductHTML) {
                                    const rvProduct = rvProductHTML.innerHTML;
                                    const targetElement = parent.querySelector(`.rv-box-${index}`);

                                    if (targetElement) {
                                        targetElement.innerHTML = rvProduct;
                                    }
                                }
                            });
                        }
                    });

                    if (enableMobileSettings && mobileDisplayProducts.length > 0) {
                        mobileDisplayProducts.forEach((product, index) => {
                            if (product) {
                                fetch(`/products/${product}?view=rv`).then(function(response) {
                                    return response.text();
                                }).then(function(data) {
                                    var parser = new DOMParser();
                                    var data = parser.parseFromString(data, "text/html");
                                    const rvProductHTML = data.querySelector(".js-recently-viewed-product");
                                    if (rvProductHTML) {
                                        const rvProduct = rvProductHTML.innerHTML;
                                        const mobileTarget = parent.querySelector(`.rv-mobile-box-${index}`);
                                        if (mobileTarget) {
                                            mobileTarget.innerHTML = rvProduct;
                                        }
                                    }
                                });
                            }
                        });
                    }

                    setTimeout(function() {
                        parent.querySelectorAll('.grid__item').forEach((grid_item, index) => {
                          if (grid_item.innerHTML.trim() === "") {
                            grid_item.remove();
                          }
                        });

                        if (parent.querySelectorAll('.grid__item').length === 0) {
                          parent.classList.add("hidden");
                          return;
                        }

                        const RecentlyViewer = parent.querySelector('[id^="RecentlyViewer-"]');
                        if (RecentlyViewer) {
                          RecentlyViewer.resetPages();
                        }

                        if (enableMobileSettings) {
                            if (displayModeMobile === 'two_row_scroll') {
                                parent.querySelectorAll('.ftr-two-row-item').forEach((item) => {
                                    if (item.innerHTML.trim() === '') item.remove();
                                });
                                parent.querySelectorAll('.ftr-two-row-slide').forEach((slide) => {
                                    if (slide.innerHTML.trim() === '') slide.remove();
                                });
                                const mobileSwiper = parent.querySelector('[id^="RvMobileSwiper"]');
                                if (mobileSwiper && typeof Swiper !== 'undefined') {
                                    new Swiper(mobileSwiper, {
                                        slidesPerView: 2.2,
                                        spaceBetween: 8,
                                        freeMode: { enabled: true, momentum: true, momentumRatio: 0.6, momentumBounce: false },
                                        grabCursor: true,
                                        touchRatio: 1,
                                        touchAngle: 45,
                                        longSwipesRatio: 0.2,
                                        longSwipesMs: 200,
                                        resistanceRatio: 0.65,
                                        threshold: 4,
                                        speed: 380,
                                        watchSlidesProgress: true,
                                        observer: true,
                                        observeParents: true,
                                        breakpoints: {
                                            768: { slidesPerView: 3.5, spaceBetween: 12 }
                                        }
                                    });
                                }
                            } else {
                                const RecentlyViewerMobile = parent.querySelector('[id^="RecentlyViewerMobile"]');
                                if (RecentlyViewerMobile) {
                                    RecentlyViewerMobile.resetPages();
                                }
                            }
                        }

                        if (typeof window.adjustVendorFontSize === 'function') {
                            window.adjustVendorFontSize();
                        }

                    }, 2000);
                }

            },

        }

    })();

    // Initialize.
	recentlyViewed.init();

    if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', () => {
            recentlyViewed.init();
        });
    }
});
